
<template>
  <div class="caidao-app-m">
    <div class="caidao-app-banner-box">
      <p>
        采道一直探索彩票从业者需要什么样的平台？
      </p>
      <p>
        彩票爱好者需要什么样的平台？
      </p>
      <p>
        采道爱好者只是需要方案推荐吗？
      </p>
      <p>
        彩票从业者只是需要营销方案或海报等吗？
      </p>
      <p>
        有着10多年经验的采道教官、有着10多年彩票经验的采道管理者、一群为采道技术研发的年轻人共同努力，我们开发出了采道平台。
      </p>
    </div>
    <div class="caidao-app-box">
      <div class="caidao-app-top">
        服务、娱乐、体验、增值是新采道为采道用户提供的服务！
      </div>

      <div class="caidao-app-content">
        <div class="caidao-app-content-item" v-for="(item, index) in list" :key="item.id">
          <img v-if="!(index % 2)"  :src="require(`@/assets/images/caidaoApp-${item.id}.png`)"  alt="">
          <div class="caidao-app-content-text">
            {{item.content}}
          </div>
          <img v-if="index % 2"  :src="require(`@/assets/images/caidaoApp-${item.id}.png`)"  alt="">
        </div>
      </div>

      <div class="caidao-app-footer">
        以上是新版本采道的冰山一角，更多惊喜等你来体验采道新版本！
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'caidao-app-m',

  data () {
    return {
      list: [
        {
          id: 1,
          content: '为彩票从业者和彩票爱好者提供分析单、数据、工具、资讯、素材服务'
        },
        {
          id: 2,
          content: '为彩票从业者和彩票爱好者提供娱乐服务'
        },
        {
          id: 3,
          content: '为彩票从业者和彩票爱好者提供最新的体验感受'
        },
        {
          id: 4,
          content: '为彩票从业者和彩票爱好者提供增值功能'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.caidao-app-m {
  .caidao-app-banner-box {
    padding: 0 20px;
    height: 245px;
    background: url('~@/assets/images/caidaoApp-top.png') 1504px top;
    background-size: auto 100%;
    @include flex(col, center);
    p {
      font-size: 12px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }
  }
  .caidao-app-box {
    padding: 40px 20px 47px;

    .caidao-app-top {
      margin-bottom: 50px;
      font-size: 20px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
    }

    .caidao-app-content {
      .caidao-app-content-item {
        height: 201px;
        margin-top: 40px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 15px;

        &:nth-child(1) {
          margin-top: none;
        }

        img {
          height: 201px;
        }

        .caidao-app-content-text {
          height: 100%;
          @include flex(col, center);
          font-size: 12px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
        }
      }
    }

    .caidao-app-footer {
      margin-top: 81px;
      font-size: 11px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
    }
  }
}
</style>
